const t = {
  name: "CrossSmall",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.0002 10.5859L8.00015 6.58594L6.58594 8.00015L10.5859 12.0002L6.58594 16.0002L8.00015 17.4144L12.0002 13.4144L16.0002 17.4144L17.4144 16.0002L13.4144 12.0002L17.4144 8.00015L16.0002 6.58594L12.0002 10.5859Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as CrossSmall
};
